/* eslint-disable import/no-cycle */
import CryptoJS from 'crypto-js';
import axios from 'axios';
import generateVersionHash from '@utils/generateVersionHash';
import { attempt, createStoreFetcher } from '@/lib/http';
import { btoa, atob, showAlert } from '../../lib/helpers';
import { dataIntervalExport, dataIntervalUpload } from '../params';
import {
  postApi,
  handleStoreApiError,
} from '../../lib/fetcher';
import api from './constants';
import unmaskingData from '../../lib/utils/unmaskingData';

const merchant = {
  namespaced: true,

  state() {
    return {
      allMerchants: [],
      totalMerchants: 0,
      loading: false,
      loadingListMerchant: false,
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      merchant: null,
      merchantDocument: [],
      countData: 0,
      countSuccess: 0,
      countFailed: 0,
      uploadProgress: 0,
      onUpload: false,
      insertProgress: 0,
      onInsert: false,
      insertName: '',
      importId: null,
      hasFailedImport: false,
      failedImportController: '',
      failedImportDate: '',
      countDone: 0,
      countSame: 0,
      intervalImport: null,
      intervalExport: null,
      exportId: null,
      countDataExport: 0,
      totalPage: 0,
      loadingStatus: false,

      requestListMerchant: null,
      requestData: null,
    };
  },

  mutations: {
    setMerchants(state, { payload }) {
      state.allMerchants = payload.data.list;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearMerchants(state) {
      state.allMerchants = [];
      state.totalMerchants = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalMerchants(state, { payload }) {
      state.totalMerchants = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    clearErrorVariable(state, variable) {
      state.errors = { ...state.errors, [variable]: [] };
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setCancelationRLMerchant(state, payload) {
      state.requestListMerchant = payload;
    },

    setLoadingListMerchant(state, loading) {
      state.loadingListMerchant = loading;
    },

    setDetailMerchant(state, { payload }) {
      state.merchant = payload;
    },
    setMerchantVariable(state, { variable, payload }) {
      state.merchant[variable] = payload;
    },

    setMerchantDocument(state, document) {
      state.merchantDocument.push(document);
    },
    setUploadProgress(state, uploadProgress) {
      state.uploadProgress = uploadProgress;
    },
    setOnUpload(state, onUpload) {
      state.onUpload = onUpload;
    },
    setInsertProgress(state, insertProgress) {
      state.insertProgress = insertProgress;
    },
    setInsertName(state, insertName) {
      state.insertName = insertName;
    },
    setOnInsert(state, onInsert) {
      state.onInsert = onInsert;
    },
    setIntervalImport(state, payload) {
      state.intervalImport = payload;
    },
    setIntervalExport(state, payload) {
      state.intervalExport = payload;
    },
    setImportData(state, payload) {
      state.importId = payload.import_id;
      state.countData = payload.count_data;
    },
    setExportData(state, payload) {
      state.exportId = payload.export_id;
      state.countDataExport = payload.count_data;
    },
    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },
    clearLastResult(state) {
      state.countData = 0;
      state.countSuccess = 0;
      state.countFailed = 0;
      state.countDone = 0;
      state.countSame = 0;
      state.uploadProgress = 0;
      state.onUpload = false;
      state.insertProgress = 0;
      state.onInsert = false;
      state.insertName = '';
      state.intervalImport = null;
      state.importId = null;
      state.hasFailedImport = false;
      state.failedImportController = '';
      state.failedImportDate = '';
    },
    setCancelation(state, payload) {
      state.requestData = payload;
    },
    setLoadingStatus(state, loading) {
      state.loadingStatus = loading;
    },
  },

  actions: {
    async validate(ctx, { date, no_rekening }) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();
      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      const data = JSON.stringify({
        account_number: no_rekening,
        version: btoa(
          CryptoJS.SHA256(
            no_rekening +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/onboarding/rekening/validate-rekening`;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      let resVal = false;
      if (responseData?.code == 200) {
        resVal = true;
      }
      return resVal;
    },

    async fetchMerchants(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search, merchantId, action }
    ) {
      ctx.commit('clearMerchants');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }
      const controller = (ctrl) => {
        switch (ctrl) {
          case 'merchant':
            return 'merchant/inputer-merchant/index';
          case 'outlet':
            return 'outlet/inputer-outlet/index';
          default:
            return 'merchant/inputer-merchant/index';
        }
      };
      const merchantIdVal = merchantId == null ? '' : merchantId;

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        merchant_id: merchantIdVal.toString(),
        version:
          merchantIdVal == ''
            ? btoa(
              CryptoJS.SHA256(
                itemsPerPage.toString() +
                    page.toString() +
                    date +
                    atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            )
            : btoa(
              CryptoJS.SHA256(
                merchantIdVal.toString() +
                    sort_by.toString() +
                    itemsPerPage.toString() +
                    page.toString() +
                    date +
                    atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
              ).toString()
            ),
      });

      const urlApi = `/index.php?r=api/v1/${controller(action)}`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData) {
        ctx.commit('setTotalMerchants', {
          payload: responseData,
        });
        ctx.commit('setMerchants', { payload: responseData });
      }
    },

    async updateSerialNumber (ctx, { date, account_id : accountId, mid, sn }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        account_id : accountId,
        mid,
        sn,
        version: btoa(
          CryptoJS.SHA256(
            accountId.toString() +
              mid.toString() +
              sn.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/merchant/inputer-merchant/update-sn`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code !== 200) {
        handleStoreApiError(ctx, responseData);
      } else {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Update Success !',
            icon: 'mdi-check-circle',
            color: 'green',
          },
          { root: true }
        );
        return responseData;
      }
      return false;
    },

    /**
     * Saves a merchant maintenance request.
     *
     * The same endpoint serves both variants of the screen: `type_edit` is `'1'`
     * for PTEN and `'2'` for non-PTEN, and only the non-PTEN variant carries the
     * regional mapping. Unique fields are sent only when the user changed them,
     * so the backend does not report a value as taken by the record being edited.
     *
     * @param {Object} ctx - Vuex action context.
     * @param {Object} params - Action payload.
     * @param {string} params.date - Timestamp used by the version hash.
     * @param {string|number} params.merchant_id - Record being maintained.
     * @param {Object} params.daerah - Selected region names.
     * @param {Object} params.tempUniqueData - Values as loaded, used to detect
     *   which unique fields changed.
     * @param {string} params.remark - Reason entered by the inputer.
     * @param {string} params.type_edit - `'1'` for PTEN, `'2'` for non-PTEN.
     * @param {Object|null} params.regionalMapping - BCKO, CMER and referral code,
     *   used by the non-PTEN variant only.
     * @param {File|null} params.mdr_file - Special MDR attachment, when present.
     * @param {*} [params.mdr_on_us_override] - Keeps the stored on-us MDR.
     * @param {*} [params.mdr_off_us_override] - Keeps the stored off-us MDR.
     * @returns {Promise<Object|false>} The response envelope, or false when the
     *   request was rejected.
     */
    async updateMerchant(
      ctx,
      { date, merchant_id, daerah, tempUniqueData, remark, type_edit, regionalMapping, mdr_file, mdr_on_us_override = null, mdr_off_us_override = null }
    ) {
      const payload = {
        merchant_id,
        merchant_name: ctx.state.merchant.merchant_name,
        ktp_no:
          tempUniqueData.ktp_no == ctx.state.merchant.ktp_no
            ? ''
            : ctx.state.merchant.ktp_no,
        mobile_phone: ctx.state.merchant.mobile_phone,
        merchant_mobile_phone: ctx.state.merchant.merchant_mobile_phone,
        company_name: ctx.state.merchant.company_name,
        owner_name: ctx.state.merchant.owner_name,
        nmid: ctx.state.merchant.nmid,
        mpan: ctx.state.merchant.mpan,
        mid: ctx.state.merchant.mid,
        qr_type: ctx.state.merchant.id_qr_type,
        sn: ctx.state.merchant.sn,
        account_type: ctx.state.merchant.id_account_type,
        merchant_criteria: ctx.state.merchant.merchant_criteria_id,
        npwp_no:
          tempUniqueData.npwp_no == ctx.state.merchant.npwp_no
            ? ''
            : ctx.state.merchant.npwp_no,
        address: ctx.state.merchant.address,
        email:
          tempUniqueData.email == ctx.state.merchant.email
            ? ''
            : ctx.state.merchant.email,
        phone: ctx.state.merchant.phone,
        phone_area_code: ctx.state.merchant.phone_area_code,
        province_name: daerah.province_name,
        city_name: daerah.city_name,
        sub_district_name: daerah.sub_district_name,
        urban_name: daerah.urban_name,
        postal_code: daerah.postal_code,
        province_id: '',
        city_id: '',
        sub_district_id: '',
        urban_id: '',
        no_rekening:
          tempUniqueData.account_number == ctx.state.merchant.account_number
            ? ''
            : ctx.state.merchant.account_number,
        endpoint: ctx.state.merchant.endpoint,
        ip_address: ctx.state.merchant.ip_address,
        approver_1: ctx.state.merchant.approver_1_id,
        approver_2: ctx.state.merchant.approver_2_id,
        mcc: ctx.state.merchant.mcc,
        mdr_on_us: mdr_on_us_override !== null ? mdr_on_us_override : ctx.state.merchant.mdr_on_us,
        mdr_off_us: mdr_off_us_override !== null ? mdr_off_us_override : ctx.state.merchant.mdr_off_us,
        bcko: type_edit === '2' ? (regionalMapping?.bcko || '') : '',
        cmer: type_edit === '2' ? (regionalMapping?.cmer || '') : '',
        referral_code:
          type_edit === '2' ? (regionalMapping?.referral_code || '') : '',
        reason: remark,
        type_edit,
        version: generateVersionHash(
          merchant_id.toString() +
            ctx.state.merchant.merchant_name.toString() +
            ctx.state.merchant.owner_name.toString() +
            ctx.state.merchant.merchant_criteria_id.toString() +
            daerah.postal_code.toString(),
          date
        ),
      };

      let data;

      if (mdr_file) {
        data = new FormData();
        Object.keys(payload).forEach((key) => {
          if (payload[key] !== null && payload[key] !== undefined) {
            if (typeof payload[key] === 'object') {
              data.append(key, JSON.stringify(payload[key]));
            } else {
              data.append(key, payload[key]);
            }
          }
        });
        data.append('mdr_file', mdr_file);
      } else {
        data = payload;
      }

      const http = createStoreFetcher(ctx);

      return attempt(async () => {
        const res = await http.post(api.UPDATE_MERCHANT, data);

        showAlert(
          ctx,
          res.message || 'Update Success !',
          'mdi-check-circle',
          'green'
        );

        return res;
      }, false);
    },

    async closeMerchant(
      ctx,
      { date, merchant_id, reason, approver_1, approver_2, closed_merchant_code }
    ) {
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        merchant_id,
        reason,
        closed_merchant_code,
        approver_1,
        approver_2,
        version: btoa(
          CryptoJS.SHA256(
            merchant_id.toString() +
              reason.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/closemerch/close-merchant/close`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 302) {
        const resData = responseData?.data;
        const errorMessage =
          (typeof resData === 'string' && resData) ||
          (typeof resData?.message === 'string' && resData.message);
        if (errorMessage) {
          showAlert(ctx, errorMessage, 'mdi-alert', 'red');
        }
        return false;
      }

      if (responseData?.code != '200') {
        handleStoreApiError(ctx, responseData);
      } else {
        return responseData;
      }
      return false;
    },

    async blockMerchant(
      ctx,
      { date, merchant_id, reason, approver_1, approver_2 }
    ) {
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        merchant_id,
        reason,
        approver_1,
        approver_2,
        version: btoa(
          CryptoJS.SHA256(
            merchant_id.toString() +
              reason.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/blockmerch/block-merchant/block`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 302) {
        const resData = responseData?.data;
        const errorMessage =
          (typeof resData === 'string' && resData) ||
          (typeof resData?.message === 'string' && resData.message);
        if (errorMessage) {
          showAlert(ctx, errorMessage, 'mdi-alert', 'red');
        }
        return false;
      }

      if (responseData?.code != '200') {
        handleStoreApiError(ctx, responseData);
      } else {
        return responseData;
      }
      return false;
    },

    async unBlockMerchant(
      ctx,
      { date, merchant_id, reason, approver_1, approver_2 }
    ) {
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        merchant_id,
        reason,
        approver_1,
        approver_2,
        version: btoa(
          CryptoJS.SHA256(
            merchant_id.toString() +
              reason.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/blockmerch/block-merchant/unblock`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == 302) {
        const resData = responseData?.data;
        const errorMessage =
          (typeof resData === 'string' && resData) ||
          (typeof resData?.message === 'string' && resData.message);
        if (errorMessage) {
          showAlert(ctx, errorMessage, 'mdi-alert', 'red');
        }
        return false;
      }

      if (responseData?.code != '200') {
        handleStoreApiError(ctx, responseData);
      } else {
        return responseData;
      }
      return false;
    },

    async viewMerchant(ctx, { date, id, isPageUpdate }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const headers = unmaskingData(id, date, isPageUpdate);

      const urlApi = `/index.php?r=api/v1/merchant/inputer-merchant/view`;

      const responseData = await postApi(ctx, urlApi, data, headers ? { headers } : {});

      if (responseData?.code == '200') {
        ctx.commit('setDetailMerchant', {
          payload: responseData.data,
        });
      }
    },

    async viewDocument(ctx, { date, id, doc_type, type, download }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        account_id: id,
        type,
        doc_type,
        download,
        version: btoa(
          CryptoJS.SHA256(
            type.toString() +
              doc_type.toString() +
              id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/document/document/view`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        return responseData.data.base64_image;
      }
      return null;
    },

    async getQRList(
      ctx,
      { date, id, page, itemsPerPage, sortBy, sortDesc, search }
    ) {
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }

      const data = JSON.stringify({
        id,
        page,
        limit: itemsPerPage,
        search,
        sort_by,
        version: btoa(
          CryptoJS.SHA256(
            id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/merchant/inputer-merchant/qr-list`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        return responseData.data;
      }
      return null;
    },

    async downloadTemplate(ctx, { action }) {
      const controller = (ctrl) => {
        switch (ctrl) {
          case 'add':
            return 'bulk-upload-merchant';
          case 'update-pten':
            return 'bulk-update-merchant';
          case 'update-non-pten':
            return 'bulk-update-merchant';
          case 'block-unblock':
            return 'bulk-block-unblock-merchant';
          default:
            return 'bulk-upload-merchant';
        }
      };
      const config = {
        method: 'post',
        url: `${
          process.env.VUE_APP_API_BASE_URL
        }/index.php?r=api/v1/onboarding/${controller(action)}/download`,
        responseType: 'blob',
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
      };
      return axios(config)
        .then((response) => response)
        .catch(async (error) => {
          let message = 'Failed to download template. Please try again.';
          if (error.response?.data instanceof Blob) {
            try {
              const parsed = JSON.parse(await error.response.data.text());
              message =
                parsed.message || parsed.message_en || parsed.message_id || message;
            } catch (e) {
              // response body is not JSON, keep the default message
            }
          }
          if (error.response?.status === 401) {
            ctx.dispatch('logout', null, { root: true });
          } else {
            showAlert(ctx, message, 'mdi-alert', 'red');
          }
          return null;
        });
    },

    async bulkUpload(
      ctx,
      {
        file,
        action,
        date,
        merchant_id,
        type_pten = null,
        type_merchant = null,
      }
    ) {
      const data = new FormData();
      data.append('file', file);
      if (type_pten) data.append('type_pten', type_pten);
      if (type_merchant) data.append('type_merchant', type_merchant);

      ctx.commit('setOnUpload', true);
      ctx.commit(
        'setInsertProgressGlobal',
        {
          absoluteBar: true,
          absoluteBarText: 'Uploading...',
        },
        { root: true }
      );
      if (merchant_id) data.append('merchant_id', merchant_id);
      const controller = (ctrl) => {
        switch (ctrl) {
          case 'add':
            return 'bulk-upload-merchant';
          case 'update-pten':
            return 'bulk-update-merchant';
          case 'update-non-pten':
            return 'bulk-update-merchant';
          case 'block-unblock':
            return 'bulk-block-merchant';
          default:
            return ctrl;
        }
      };

      const failed = () => {
        ctx.commit('setOnUpload', false);
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Upload Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: false,
            absoluteBarText: '',
          },
          { root: true }
        );
      };

      try {
        const urlApi = `/index.php?r=api/v1/onboarding/${controller(
          action
        )}/import`;

        const addConfig = {
          onUploadProgress(progressEvent) {
            ctx.commit(
              'setUploadProgress',
              parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100),
                10
              )
            );
          },
        };

        const responseData = await postApi(ctx, urlApi, data, addConfig);

        if (responseData?.code == '200') {
          ctx.commit('setImportData', responseData.data);
          const interval = setInterval(() => {
            ctx.dispatch('importStatus', {
              date,
              controller: controller(action),
            });
          }, dataIntervalUpload);
          ctx.commit('setIntervalImport', interval);
          ctx.commit('setInsertName', 'Start to insert data..');
          ctx.commit('setOnInsert', true);
          ctx.commit(
            'setInsertProgressGlobal',
            {
              absoluteBar: true,
              absoluteBarText: 'Start to insert data..',
            },
            { root: true }
          );
        } else {
          failed();
          if (responseData.code == '302') {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: responseData.data.message,
                icon: 'mdi-alert',
                color: 'red',
              },
              { root: true }
            );
          }
        }
        ctx.commit('setOnUpload', false);
        return responseData;
      } catch (error) {
        failed();
        return false;
      }
    },

    async importStatus(ctx, { date, controller }) {
      const data = JSON.stringify({
        import_id: ctx.state.importId,
        count_data: ctx.state.countData,
        version: btoa(
          CryptoJS.SHA256(
            ctx.state.importId.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const failed = () => {
        clearInterval(ctx.state.intervalImport);
        ctx.commit('setOnInsert', false);
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Upload Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: false,
            absoluteBarText: '',
          },
          { root: true }
        );
      };

      try {
        const urlApi = `/index.php?r=api/v1/onboarding/${controller}/status-import`;

        const responseData = await postApi(ctx, urlApi, data);

        if (responseData?.code == '00') {
          clearInterval(ctx.state.intervalImport);
          ctx.commit('setOnInsert', false);
          ctx.commit('setStateVariable', {
            variable: 'countSuccess',
            payload: responseData.data.count_success,
          });
          ctx.commit('setStateVariable', {
            variable: 'countFailed',
            payload: responseData.data.count_failed,
          });
          if (responseData.data.count_success != ctx.state.countData) {
            ctx.commit('setStateVariable', {
              variable: 'failedImportController',
              payload: controller,
            });
            ctx.commit('setStateVariable', {
              variable: 'failedImportDate',
              payload: date,
            });
            ctx.commit('setStateVariable', {
              variable: 'hasFailedImport',
              payload: true,
            });
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: 'Upload done with some failed record !',
                icon: 'mdi-alert',
                color: 'orange',
              },
              { root: true }
            );
          } else {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: 'Success, Bulk Upload Done !',
                icon: 'mdi-alert',
                color: 'green',
              },
              { root: true }
            );
          }
          ctx.commit(
            'setInsertProgressGlobal',
            {
              absoluteBar: false,
              absoluteBarText: '',
            },
            { root: true }
          );
        } else if (responseData?.code == 'A0') {
          const totalDataDone =
            parseInt(responseData.data.count_success, 10) +
            parseInt(responseData.data.count_failed, 10);
          ctx.commit(
            'setInsertName',
            `Insert ${totalDataDone}/${ctx.state.countData} data..`
          );
          ctx.commit(
            'setInsertProgress',
            (totalDataDone / ctx.state.countData) * 100
          );
          ctx.commit(
            'setInsertProgressGlobal',
            {
              absoluteBar: true,
              absoluteBarText: `Insert ${totalDataDone}/${ctx.state.countData} data..`,
            },
            { root: true }
          );
        } else {
          failed();
        }
      } catch (error) {
        failed();
      }
    },

    async downloadFailedImport(ctx) {
      const date = ctx.state.failedImportDate;
      const controller = ctx.state.failedImportController;
      const data = JSON.stringify({
        import_id: ctx.state.importId,
        version: btoa(
          CryptoJS.SHA256(
            ctx.state.importId.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/onboarding/${controller}/download-failed-import`,
        responseType: 'blob',
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => response)
        .catch(async (error) => {
          let message = 'Failed to download failed records. Please try again.';
          if (error.response?.data instanceof Blob) {
            try {
              const parsed = JSON.parse(await error.response.data.text());
              message =
                parsed.message || parsed.message_en || parsed.message_id || message;
            } catch (e) {
              // response body is not JSON, keep the default message
            }
          }
          if (error.response?.status === 401) {
            ctx.dispatch('logout', null, { root: true });
          } else {
            showAlert(ctx, message, 'mdi-alert', 'red');
          }
          return null;
        });
    },

    async exportList(
      ctx,
      { date, page, itemsPerPage, sortBy, sortDesc, search, view, IDMerchant }
    ) {
      if (ctx.rootState.isExport) {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export in progress !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        return;
      }
      ctx.commit('setLoading', true);
      ctx.commit('setIsExport', true, { root: true });
      ctx.commit('setStateVariable', {
        payload: 0,
        variable: 'countSameExport',
      });
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      let sort_by = '';
      if (sortBy[0] != null) {
        sort_by = `${sortBy[0]} ${sort}`;
      } else {
        sort_by = `id ${sort}`;
      }

      const controller = (ctrl) => {
        switch (ctrl) {
          case 'merchant':
            return 'export-inputer-merchant';
          case 'merchant-outlet':
            return 'export-inputer-outlet';
          default:
            return 'export-inputer-merchant';
        }
      };

      const version = btoa(
        CryptoJS.SHA256(
          IDMerchant.toString() +
            itemsPerPage.toString() +
            page.toString() +
            date +
            atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
        ).toString()
      );

      const data = JSON.stringify({
        search,
        sort_by,
        limit: itemsPerPage.toString(),
        page: page.toString(),
        merchant_id: IDMerchant.toString(),
        version,
      });

      const failed = () => {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Export Failed !',
            icon: 'mdi-alert',
            color: 'red',
          },
          { root: true }
        );
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: false,
            absoluteBarText: '',
          },
          { root: true }
        );
        ctx.commit('setIsExport', false, { root: true });
      };

      const urlApi = `/index.php?r=api/v1/export/${controller(view)}/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code == '200') {
        if (responseData.data.message != null) {
          ctx.commit(
            'setSnackbar',
            {
              status: true,
              message: responseData.data.message,
              icon: 'mdi-alert',
              color: 'red',
            },
            { root: true }
          );
          ctx.commit('setIsExport', false, { root: true });
          return;
        }
        ctx.commit('setExportData', responseData.data);
        const interval = setInterval(() => {
          ctx.dispatch(
            'exportStatus',
            {
              date,
              exportId: ctx.state.exportId,
              countDataExport: ctx.state.countDataExport,
              controller: controller(view),
            },
            { root: true }
          );
        }, dataIntervalExport);
        ctx.commit('setIntervalExport', interval, { root: true });
        ctx.commit(
          'setInsertProgressGlobal',
          {
            absoluteBar: true,
            absoluteBarText: 'Start to export data..',
          },
          { root: true }
        );
      } else {
        failed();
      }
    },

    async getListMerchant(ctx, { date, aggregatorId, searchMerchant }) {
      if (ctx.state.requestListMerchant) ctx.state.requestListMerchant.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelationRLMerchant', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('setLoadingListMerchant', true);

      const data = JSON.stringify({
        search: searchMerchant,
        aggregator_id: aggregatorId.toString(),
        version: btoa(
          CryptoJS.SHA256(
            aggregatorId.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/onboarding/bulk-list-merchant/merchant-list`;
      const addConfig = { cancelToken: axiosSource.token };
      const responseData = await postApi(ctx, urlApi, data, addConfig);

      let resVal = false;
      if (responseData?.code == '200') {
        resVal = responseData.data;
      }
      ctx.commit('setLoadingListMerchant', false);
      return resVal;
    },

    async generateMerchant(
      ctx,
      { date, merchant_id, type_pten, aggregator_id }
    ) {
      const action =
        aggregator_id == '' ? 'generate-merchant' : 'generate-sub-merchant';

      const data = JSON.stringify({
        merchant_id,
        type_pten: type_pten.toString(),
        aggregator_id: aggregator_id.toString(),
        version: btoa(
          CryptoJS.SHA256(
            type_pten.toString() +
              aggregator_id.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const config = {
        method: 'post',
        url: `${process.env.VUE_APP_API_BASE_URL}/index.php?r=api/v1/onboarding/bulk-list-merchant/${action}`,
        responseType: 'blob',
        headers: {
          'X-CSRF-TOKEN': JSON.parse(localStorage.getItem('logged_in_qram'))
            .token,
          'Content-Type': 'application/json',
          'X-Origin-Path': window.location.pathname
        },
        data,
      };
      return axios(config)
        .then((response) => response)
        .catch(async (error) => {
          let message = 'Failed to download merchant data. Please try again.';
          if (error.response?.data instanceof Blob) {
            try {
              const parsed = JSON.parse(await error.response.data.text());
              message =
                parsed.message || parsed.message_en || parsed.message_id || message;
            } catch (e) {
              // response body is not JSON, keep the default message
            }
          }
          if (error.response?.status === 401) {
            ctx.dispatch('logout', null, { root: true });
          } else {
            showAlert(ctx, message, 'mdi-alert', 'red');
          }
          return null;
        });
    },
  },
};

export default merchant;
